var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "manageWrapper" }, [
    _c("div", { staticClass: "search-container" }, [
      _c(
        "div",
        {
          staticClass:
            "manage-header d-flex align-items-start justify-content-between"
        },
        [
          _c("div", { staticClass: "w-50 d-flex align-items-center" }, [
            _c("span", { staticClass: "title" }, [_vm._v("Manage")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "item ml-2" },
              [
                _c("multiselect", {
                  staticClass: "content",
                  attrs: {
                    options: _vm.programClientList,
                    placeholder: _vm.programClientList
                      ? _vm.programClientSelected.name
                      : "Empty",
                    label: "name",
                    openDirection: "below",
                    multiple: false,
                    "close-on-select": true,
                    "hide-selected": true,
                    "track-by": "name",
                    "allow-empty": true,
                    "show-labels": false
                  },
                  on: { select: _vm.selectProgramItemClick },
                  model: {
                    value: _vm.programClientSelected,
                    callback: function($$v) {
                      _vm.programClientSelected = $$v
                    },
                    expression: "programClientSelected"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("b-button", { on: { click: _vm.onManageClientSettings } }, [
            _vm._v("\n        Manage Client Settings\n      ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container-filter" }, [
        _c("div", { staticClass: "filter-date-range" }, [
          _c("div", { staticClass: "text-container" }, [
            _c("p", { staticClass: "text-date-range" }, [
              _vm._v("Filter by date range")
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "text-clear", on: { click: _vm.clearFilter } },
              [_vm._v("Clear Filters")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field-filter d-flex align-items-center" },
            [
              _c("b-form-input", {
                attrs: { type: "date", locale: "en-US" },
                on: {
                  keydown: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onChange($event)
                  }
                },
                model: {
                  value: _vm.startDate,
                  callback: function($$v) {
                    _vm.startDate = $$v
                  },
                  expression: "startDate"
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("to")]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: { type: "date", locale: "en-US" },
                on: {
                  keydown: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onChange($event)
                  }
                },
                model: {
                  value: _vm.endDate,
                  callback: function($$v) {
                    _vm.endDate = $$v
                  },
                  expression: "endDate"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-events" },
          [
            _c("p", [_vm._v("Search")]),
            _vm._v(" "),
            _c(
              "b-input-group",
              { staticClass: "search-events-group" },
              [
                _c("b-form-input", {
                  attrs: {
                    type: "text",
                    placeholder: "Search by event information"
                  },
                  nativeOn: {
                    keydown: function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onSearch($event)
                    }
                  },
                  model: {
                    value: _vm.keyword,
                    callback: function($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword"
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  { on: { click: _vm.onChange } },
                  [
                    _c("Icon", {
                      staticClass: "search-icon",
                      attrs: { name: "search" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "total-count" }, [
          _vm._v(
            "\n        Event Count: " +
              _vm._s(_vm.totalEvents()) +
              "/" +
              _vm._s(_vm.totalCountOfClient) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "list-events" }, [
      _c("div", { staticClass: "list-header" }, [
        _c("div", { staticClass: "column event-date" }, [
          _c(
            "div",
            { staticClass: "container-column border-seperate" },
            [
              _c("p", { staticClass: "text-header" }, [_vm._v("Event Date")]),
              _vm._v(" "),
              _c("b-button", { on: { click: _vm.onSort } }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../static/img/arrow-down.svg"),
                    alt: "icon"
                  }
                })
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _vm._m(6)
      ]),
      _vm._v(" "),
      _vm.loadingList
        ? _c(
            "div",
            { staticClass: "list-loading d-flex justify-content-center" },
            [
              _c("b-spinner", {
                attrs: { variant: "primary", label: "Spinning" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loadingList
        ? _c(
            "div",
            [
              _vm._l(_vm.getListSingleEvent, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "list-container" },
                  [
                    item.status === "APPROVED" || _vm.isShowArchivedEvent(item)
                      ? _c(
                          "div",
                          {
                            class:
                              "list-content " +
                              (_vm.isShowArchivedEvent(item)
                                ? "green-line"
                                : "")
                          },
                          [
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [_c("p", [_vm._v(_vm._s(item.prefDate))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [_c("p", [_vm._v(_vm._s(item.eventName))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [
                                  _c("div", { staticClass: "text-icon" }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../../static/img/ball-green.svg"),
                                        alt: "icon"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(_vm._s(item.trackingStatus))
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [
                                  _c("div", { staticClass: "text-icon" }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../../static/img/ball-red.svg"),
                                        alt: "icon"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(item.numParticipant) +
                                          "/" +
                                          _vm._s(item.maxParticipant) +
                                          " Participants"
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [_c("p", [_vm._v(_vm._s(item.fullAddress))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-column border-seperate"
                                },
                                [
                                  _c("div", { staticClass: "text-icon" }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../../static/img/ball-red.svg"),
                                        alt: "icon"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          item.numStaffLead +
                                            item.numStaffConcierge +
                                            item.numStaffScreener
                                        ) +
                                          "/" +
                                          _vm._s(
                                            item.maxStaffLead +
                                              item.maxStaffConcierge +
                                              item.maxStaffScreener
                                          ) +
                                          " Staff"
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column event-date" }, [
                              _c("div", { staticClass: "container-column" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "live-click",
                                    on: {
                                      click: function($event) {
                                        _vm.onMakeLive(item)
                                      }
                                    }
                                  },
                                  [
                                    item.isLive
                                      ? _c(
                                          "div",
                                          { staticClass: "text-icon" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../../../static/img/live-blue.svg"),
                                                alt: "icon"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v("Live")])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !item.isLive
                                      ? _c(
                                          "p",
                                          { staticClass: "text-not-live" },
                                          [_vm._v("Not Live")]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "button-view" },
                                  [
                                    _c("b-button", {
                                      staticClass: "btn-expand",
                                      on: {
                                        click: function($event) {
                                          _vm.onEventDetails(item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "load-more" },
                [
                  _c("b-spinner", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loadMoreLoading,
                        expression: "loadMoreLoading"
                      }
                    ],
                    attrs: { variant: "primary", label: "Spinning" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.getListEventGroup, function(group) {
                  return _c(
                    "div",
                    { staticClass: "list-group-container" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "container-text d-flex align-items-center"
                        },
                        [
                          _c("b", [_vm._v(_vm._s(group.name) + ":")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(group.minDateEventGroup) +
                              " - " +
                              _vm._s(group.maxDateEventGroup) +
                              "\n            "
                          ),
                          _c("div", { staticClass: "seperate" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(group.data.length) +
                              "/" +
                              _vm._s(group.totalCount) +
                              " events\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(group.data, function(relatedEvent) {
                        return _c(
                          "div",
                          { staticClass: "list-ca container-ca" },
                          [
                            relatedEvent.status === "APPROVED" ||
                            _vm.isShowArchivedEvent(relatedEvent)
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      "list-group-row " +
                                      (_vm.isShowArchivedEvent(relatedEvent)
                                        ? "green-line"
                                        : "")
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(relatedEvent.prefDate)
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(relatedEvent.eventName)
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "text-icon" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../../static/img/ball-green.svg"),
                                                    alt: "icon"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      relatedEvent.trackingStatus
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "text-icon" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../../static/img/ball-red.svg"),
                                                    alt: "icon"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      relatedEvent.numParticipant
                                                    ) +
                                                      "/" +
                                                      _vm._s(
                                                        relatedEvent.maxParticipant
                                                      ) +
                                                      " Participants"
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(relatedEvent.fullAddress)
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "container-column border-seperate"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "text-icon" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../../static/img/ball-red.svg"),
                                                    alt: "icon"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      relatedEvent.numStaffLead +
                                                        relatedEvent.numStaffConcierge +
                                                        relatedEvent.numStaffScreener
                                                    ) +
                                                      "/" +
                                                      _vm._s(
                                                        relatedEvent.maxStaffLead +
                                                          relatedEvent.maxStaffConcierge +
                                                          relatedEvent.maxStaffScreener
                                                      ) +
                                                      " Staff"
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column event-date" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "container-column" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "live-click",
                                                on: {
                                                  click: function($event) {
                                                    _vm.onMakeLive(relatedEvent)
                                                  }
                                                }
                                              },
                                              [
                                                relatedEvent.isLive
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "text-icon"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("../../../../static/img/live-blue.svg"),
                                                            alt: "icon"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v("Live")
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !relatedEvent.isLive
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-not-live"
                                                      },
                                                      [_vm._v("Not Live")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "button-view" },
                                              [
                                                _c("b-button", {
                                                  staticClass: "btn-expand",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.onEventDetails(
                                                        relatedEvent
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      })
                    ],
                    2
                  )
                })
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "load-more" },
                [
                  _vm.showLoadMoreBtn()
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn btn-secondary",
                          on: { click: _vm.onLoadMore }
                        },
                        [_vm._v("\n          Load More\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadMoreLoading
                    ? _c("b-spinner", {
                        attrs: { variant: "primary", label: "Spinning" }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("p", { staticClass: "text-manage-events" }, [
          _vm._v("Manage your events that are approved and scheduled")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Event Name")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Supply Status")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Participant Signups")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Event Address")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column border-seperate" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Staffing")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column event-date" }, [
      _c("div", { staticClass: "container-column" }, [
        _c("p", { staticClass: "text-header" }, [_vm._v("Live")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22d493a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d493a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/main/Manage.vue
// module id = 1955
// module chunks = 1